
import { Vue, Component, Prop } from 'vue-property-decorator'
import DashboardOrder from '../../components/Dashboards/DashboardOrder.vue'
  @Component({
    name: 'student',
    components: { DashboardOrder }
  })
export default class student extends Vue {
  mounted() {}
}
